export default {
    name: 'divider',
    title: '分割线',
    text: '',
    dashed: false,
    position: 'center',
    color: '#969799',
    borderColor: '#969799',
}